// src/components/shops/postTemplates/Gift.tsx
//
// A gift-tag card for the gifting push every shop makes in December — gift
// cards, bundles, a mug-and-beans set. The punched hole and string at the top
// read instantly as "a present," which is the whole job: it says gift before a
// word is read.

import { cachedUrl } from '../../../lib/storageUrl'
import SocialBrewBadge from '../SocialBrewBadge'
import { categoryLabel, type TemplateProps } from './types'

export default function Gift({
  title, body, photos, category, shopName, rating, ratingCount, scale = 1,
}: TemplateProps) {
  const px = (n: number) => `${n * scale}px`
  const label = categoryLabel(category) || 'For gifting'
  const photo = photos[0]

  return (
    <div
      style={{ background: '#3a2417', borderRadius: px(3), padding: `${px(14)} ${px(16)} ${px(16)}` }}
      data-shop={shopName}
    >
      {/* String + punched hole — the gift-tag cue */}
      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: px(8) }}>
        <div
          style={{
            width: px(13),
            height: px(13),
            borderRadius: '50%',
            border: `${px(2)} solid #d8b98a`,
            background: '#3a2417',
          }}
        />
      </div>

      <div
        style={{
          background: 'linear-gradient(180deg,#f6ecdb,#eaddc6)',
          borderRadius: px(2.5),
          padding: `${px(18)} ${px(18)} ${px(16)}`,
          border: `${px(0.75)} dashed rgba(164,101,42,0.45)`,
        }}
      >
        <p
          style={{
            fontSize: px(8.5),
            letterSpacing: '0.3em',
            textTransform: 'uppercase',
            color: '#a4652a',
            fontWeight: 700,
            marginBottom: px(9),
          }}
        >
          🎁 &nbsp;{label}
        </p>

        <h3
          className="font-display"
          style={{
            fontSize: px(24),
            lineHeight: 1.14,
            letterSpacing: '-0.015em',
            color: '#2a1c12',
            fontWeight: 700,
            margin: 0,
            textWrap: 'balance',
          }}
        >
          {title}
        </h3>

        {body && (
          <p style={{ fontSize: px(13), lineHeight: 1.6, color: 'rgba(60,40,20,0.72)', marginTop: px(9) }}>
            {body}
          </p>
        )}

        {photo && (
          <div style={{ borderRadius: px(2), overflow: 'hidden', marginTop: px(14), aspectRatio: '16 / 9' }}>
            <img src={cachedUrl(photo)} alt="" loading="lazy" className="w-full h-full object-cover" />
          </div>
        )}

        <div style={{ marginTop: px(16) }}>
          <SocialBrewBadge rating={rating} ratingCount={ratingCount} tone="light" scale={scale} />
        </div>
      </div>
    </div>
  )
}
